import { useRef } from 'react';

import { useModal } from 'mui-modal-provider';

import { Cluster } from '@cast/types';

import { HibernateClusterDialog } from './HibernateClusterDialog';

import { ShowModalOutput } from '@cast/design-system';

export const useHibernateClusterDialog = () => {
  const { showModal } = useModal();
  const modalInstance = useRef<ShowModalOutput>(undefined);

  const openHibernateClusterDialog = (cluster: Cluster) => {
    modalInstance.current = showModal(HibernateClusterDialog, {
      onClose: () => modalInstance.current?.destroy(),
      cluster,
    });
  };

  return {
    openHibernateClusterDialog,
  };
};
